import React from "react"
import { TimerContext } from "@layerhub-io/use-timer"
import { Block } from "baseui/block"
import { DesignEditorContext } from "~/contexts/DesignEditor"

const SCALE_FACTOR = 1

export default function () {
  const { time, setTime, pause } = React.useContext(TimerContext)

  const [position, setPosition] = React.useState({
    x: 0,
    y: 0,
  })
  const { scenes, maxTime, setMaxTime } = React.useContext(DesignEditorContext)

  React.useEffect(() => {
    if (time * SCALE_FACTOR <= maxTime) {
      setPosition({ ...position, x: (time * SCALE_FACTOR) / 40, y: 0 })
    } else {
      pause()
    }
  }, [time])

  React.useEffect(() => {
    if (scenes) {
      const maxTime = scenes.reduce(function (previousVal, currentValue) {
        return previousVal + currentValue.duration!
      }, 0)
      setMaxTime(maxTime)
    }
  }, [scenes])

  const onStart = (ev: React.MouseEvent) => {
    // 1px === 40ms, matching the marker position (time / 40).
    const startClientX = ev.clientX
    const startTime = time

    const onDrag = (event: MouseEvent) => {
      const delta = event.clientX - startClientX
      const newTime = Math.max(0, Math.min(startTime + delta * 40, maxTime - 1))
      setTime(newTime)
    }

    const onStop = () => {
      window.removeEventListener("mousemove", onDrag)
      window.removeEventListener("mouseup", onStop)
    }

    window.addEventListener("mousemove", onDrag)
    window.addEventListener("mouseup", onStop)
  }

  return (
    <>
      <Block
        onMouseDown={onStart}
        $style={{
          position: "absolute",
          zIndex: 3,
          left: `${position.x}px`,
          top: "-2px",
          width: "2px",
          bottom: "0px",
        }}
      >
        <Block
          id={"EditorPlayHead"}
          $style={{
            width: 0,
            height: 0,
            borderLeft: "9px solid transparent",
            borderRight: "9px solid transparent",
            borderTop: "11px solid #333333",
            borderRadius: "5px",
            transform: "translate(-8px, -1px)",
          }}
        />

        <Block
          id="markerLine"
          $style={{
            height: "84px",
            width: "2px",
            backgroundColor: "#333333",
            transform: "translate(0, -2px)",
          }}
        />
      </Block>
    </>
  )
}
